// src/pages/BooksByAuthorPage.jsx

import { useParams } from "react-router-dom"; // Assuming you're using react-router-dom for routing
import AuthorProfile from "./BooksByAuthorComponents/AuthorProfile";
import BooksByAuthor from "./BooksByAuthorComponents/BooksByAuthor";

const BooksByAuthorP = () => {
  const { authorId } = useParams(); // Get the authorId from the route params

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Author Profile Section */}
      <div className="container mx-auto px-4 py-4">
        <AuthorProfile authorId={authorId} />
      </div>

      {/* Books By Author Section */}
      <div className="container mx-auto px-4">
        <BooksByAuthor authorId={authorId} />
      </div>
    </div>
  );
};

export default BooksByAuthorP;
